import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "schedule-meeting-modal" }
const _hoisted_2 = { class: "modal-container flex-center" }
const _hoisted_3 = { class: "progress-bar" }
const _hoisted_4 = { class: "content flex-center" }
const _hoisted_5 = { class: "content__options" }
const _hoisted_6 = {
  key: 0,
  class: "phone-number"
}
const _hoisted_7 = {
  key: 1,
  class: "email"
}
const _hoisted_8 = {
  key: 2,
  class: "no-contact"
}
const _hoisted_9 = { class: "content__calendar" }
const _hoisted_10 = { class: "schedule-buttons flex-center" }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = { class: "content" }
const _hoisted_13 = { class: "schedule-buttons flex-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      ($props.selectedEvent && $props.selectedEvent.eventType === $setup.CalendarEvents.EventType.TrainingRequest)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_3, [
              _cache[7] || (_cache[7] = _createElementVNode("div", { class: "grey-bar" }, null, -1)),
              _createElementVNode("div", {
                class: _normalizeClass(["progress-icon info", {reached: $setup.mode >= $setup.SetupStage.CONTACT, current: $setup.mode == $setup.SetupStage.CONTACT}])
              }, _cache[4] || (_cache[4] = [
                _createElementVNode("div", { class: "step-name" }, "Contact", -1)
              ]), 2),
              _createElementVNode("div", {
                class: _normalizeClass(["progress-icon dog", {reached: $setup.mode >= $setup.SetupStage.TYPE, current: $setup.mode == $setup.SetupStage.TYPE}])
              }, _cache[5] || (_cache[5] = [
                _createElementVNode("div", { class: "step-name" }, "Services", -1)
              ]), 2),
              _createElementVNode("div", {
                class: _normalizeClass(["progress-icon calendar", {reached: $setup.mode >= $setup.SetupStage.DATE, current: $setup.mode == $setup.SetupStage.DATE}])
              }, _cache[6] || (_cache[6] = [
                _createElementVNode("div", { class: "step-name" }, "Date", -1)
              ]), 2)
            ]),
            _createElementVNode("div", _hoisted_4, [
              ($setup.mode == $setup.SetupStage.CONTACT)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _cache[10] || (_cache[10] = _createElementVNode("div", { class: "content__heading" }, "Contact the customer", -1)),
                    _createElementVNode("div", _hoisted_5, [
                      ($setup.eventUser?.phone)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                            _cache[8] || (_cache[8] = _createElementVNode("strong", null, "Customer Phone Number:", -1)),
                            _createTextVNode(" " + _toDisplayString($setup.eventUser?.phone), 1)
                          ]))
                        : _createCommentVNode("", true),
                      ($setup.eventUser?.email)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                            _cache[9] || (_cache[9] = _createElementVNode("strong", null, "Customer Email:", -1)),
                            _createTextVNode(" " + _toDisplayString($setup.eventUser?.email), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (!$setup.eventUser?.email && !$setup.eventUser?.phone )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, "Customer has no provided contact info"))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", { class: "actions" }, [
                        _createElementVNode("button", {
                          class: "g-primary",
                          onClick: $setup.deleteRequest
                        }, "Delete request")
                      ])
                    ])
                  ], 64))
                : ($setup.mode == $setup.SetupStage.TYPE)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _cache[11] || (_cache[11] = _createElementVNode("div", { class: "content__heading" }, "Determine training method", -1)),
                      _cache[12] || (_cache[12] = _createElementVNode("div", { class: "content__select" }, "Select the type of training they need TODO", -1))
                    ], 64))
                  : ($setup.mode == $setup.SetupStage.DATE)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                        _cache[13] || (_cache[13] = _createElementVNode("div", { class: "content__heading" }, "Establish pickup and dropoff date/times", -1)),
                        _createElementVNode("div", _hoisted_9, [
                          _createVNode($setup["CalendarPicker"], {
                            dropOffTime: $setup.startDateTime,
                            "onUpdate:dropOffTime": _cache[0] || (_cache[0] = ($event: any) => (($setup.startDateTime) = $event)),
                            pickUpTime: $setup.endDateTime,
                            "onUpdate:pickUpTime": _cache[1] || (_cache[1] = ($event: any) => (($setup.endDateTime) = $event))
                          }, null, 8, ["dropOffTime", "pickUpTime"])
                        ])
                      ], 64))
                    : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("button", {
                class: "g-primary",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('close')))
              }, "Cancel"),
              _createElementVNode("button", {
                class: "g-outline continue",
                disabled: $setup.disableContinue,
                onClick: $setup.progressStage
              }, "Continue", 8, _hoisted_11)
            ])
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", _hoisted_12, "Event: " + _toDisplayString($props.selectedEvent), 1),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("button", {
                class: "g-primary",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('close')))
              }, "Cancel")
            ])
          ], 64))
    ])
  ]))
}